import { PropertyValues } from '@lit/reactive-element';
import { TmBaseComponent } from '@treasury/presentation/tm-base.component';
import { dispatchFilterFormEvent, TmFilterFormEvent } from './tm-filter-form.types';

export abstract class TmFilterForm<T = unknown> extends TmBaseComponent {
    protected abstract filter?: T;

    public abstract get isValid(): boolean;

    public abstract reset(): void;

    public applyFilter() {
        dispatchFilterFormEvent(this, TmFilterFormEvent.Apply, this.filter);
    }

    protected updated(_changedProperties: PropertyValues): void {
        if (_changedProperties.has('filter')) {
            this.changeValidity();
        }
    }

    protected changeValidity() {
        dispatchFilterFormEvent(this, TmFilterFormEvent.ValidityChange, undefined);
    }
}
